<template>
  <div class="Echarts">
    <Card style="width: 100%;height:600px;">
      <div id="main" style="width: 100%;height:550px;"></div>
    </Card>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  props: {
    // startTime: String,
    // endTime: String,
    getData: {
      type: Array,
      required: true
    },
    startTime: {
      type: String,
      default: ""
    },
    endTime: {
      type: String,
      default: ""
    },
    homeTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      upColor: "#00da3c",
      downColor: "#ec0000",
      dataCount: 20,
      quoteData: []
    };
  },
  methods: {
    // splitData(rawData) {
    //   var categoryData = [];
    //   var values = [];
    //   var volumes = [];
    //   for (var i = 0; i < rawData.length; i++) {
    //     categoryData.push(rawData[i].splice(0, 1)[0]);
    //     values.push(rawData[i]);
    //     volumes.push([
    //       i,
    //       rawData[i][4],
    //       rawData[i][0] > rawData[i][1] ? 1 : -1
    //     ]);
    //   }

    //   return {
    //     categoryData: categoryData,
    //     values: values,
    //     volumes: volumes
    //   };
    // },
    generateOHLC(count) {
      var data = [];
      for (var i = 0; i < count.length; i++) {
        data[i] = [
          count[i].tradeTime, // 交易时间
          count[i].openPrice, // 开
          count[i].lowPrice, // 低
          count[i].highPrice, // 高
          count[i].closePrice, // 收
          count[i].volume, // 成交量
          count[i].turnOver, // 成交额turnOver
          count[i].raisePoint, // 涨跌
          count[i].openInterest == "nan" ? "--" : count[i].openInterest, // 持仓量
          count[i].chg, // 涨幅
          this.getInitChg(count[i].chg) // 涨幅
          // this.getSign(data, i, +boxVals[openIdx], +boxVals[closeIdx], 4) // sign
        ];
      }
      return data;
    },
    getInitChg(item) {
      var sign;
      if (item > 0) {
        sign = 1;
      } else {
        sign = -1;
      }
      return sign;
    },

    generateOHLCTEST(count) {
      var data = [];
      var xValue = +new Date(2011, 0, 1);
      var minute = 60 * 1000;
      var baseValue = Math.random() * 12000;
      var boxVals = new Array(4);
      var dayRange = 12;
      for (var i = 0; i < count; i++) {
        baseValue = baseValue + Math.random() * 20 - 10;
        for (var j = 0; j < 4; j++) {
          boxVals[j] = (Math.random() - 0.5) * dayRange + baseValue;
        }
        boxVals.sort();

        var openIdx = Math.round(Math.random() * 3);
        var closeIdx = Math.round(Math.random() * 2);
        if (closeIdx === openIdx) {
          closeIdx++;
        }
        var volumn = boxVals[3] * (1000 + Math.random() * 500);
        // ['open', 'close', 'lowest', 'highest', 'volumn']
        // [1, 4, 3, 2]
        data[i] = [
          echarts.format.formatTime("yyyy-MM-dd\nhh:mm:ss", (xValue += minute)),
          +boxVals[openIdx].toFixed(2), // open
          +boxVals[3].toFixed(2), // highest
          +boxVals[0].toFixed(2), // lowest
          +boxVals[closeIdx].toFixed(2), // close
          volumn.toFixed(0),
          this.getSign(data, i, +boxVals[openIdx], +boxVals[closeIdx], 4) // sign
        ];
      }
      return data;
    },
    getSign(data, dataIndex, openVal, closeVal, closeDimIdx) {
      var sign;
      if (openVal > closeVal) {
        sign = -1;
      } else if (openVal < closeVal) {
        sign = 1;
      } else {
        sign =
          dataIndex > 0
            ? // If close === open, compare with close of last record
              data[dataIndex - 1][closeDimIdx] <= closeVal
              ? 1
              : -1
            : // No record of previous, set to be positive
              1;
      }

      return sign;
    },
    echartsInit() {
      var upColor = "#ec0000";
      var downColor = "#00da3c";
      var upBorderColor = null; // "#8A0000";
      var downBorderColor = null; // "#008F28";
      // var data = this.generateOHLC(this.getData);
      // var data = this.generateOHLCTEST(10);
      var data = this.generateOHLC(this.getData);
      var myChart = this.$echarts.init(document.getElementById("main"));
      var dataArray = [
        "product",
        "0",
        "0",
        "0",
        "0",
        "0",
        "0",
        "0",
        "0",
        "0",
        "0"
      ];
      var option = {
        backgroundColor: "#fff",
        dataset: {
          source: [dataArray, ...data]
        },
        title: {
          text: this.homeTitle
        },
        tooltip: {
          trigger: "axis",
          // axisPointer: {
          //   type: "cross" // 隐藏鼠标移入的辅助提示线
          // },
          // trigger: "axis",
          // axisPointer: {
          //   type: "line" // line\cross
          // },
          // trigger: "item",
          formatter: function(params) {
            let openInterest = "";
            if (params[0].value[8] != "--") {
              openInterest += "<br>" + "持仓量:" + params[0].value[8];
            }
            return (
              params[0].name +
              "<br>" +
              "开盘:" +
              params[0].value[1] +
              "<br>" +
              "收盘:" +
              params[0].value[4] +
              "<br>" +
              "最低:" +
              params[0].value[2] +
              "<br>" +
              "最高:" +
              params[0].value[3] +
              "<br>" +
              "成交额:" +
              params[0].value[6] +
              "<br>" +
              "成交量:" +
              params[0].value[5] +
              "<br>" +
              "涨跌:" +
              Number(params[0].value[7]).toFixed(2) +
              openInterest +
              "<br>" +
              "涨幅:" +
              Number(params[0].value[9]).toFixed(2)+'%'
            );
          }

          // backgroundColor: "rgba(245, 245, 245, 0.8)",
          // borderWidth: 1,
          // borderColor: "#ccc",
          // padding: 10,
          // textStyle: {
          //   color: "#000"
          // },
          // extraCssText: "width: 170px"
        },
        // toolbox: {
        //   feature: {
        //     dataZoom: {
        //       yAxisIndex: false
        //     }
        //   }
        // },
        grid: [
          {
            left: "10%",
            right: "10%",
            bottom: 200
          },
          {
            left: "10%",
            right: "10%",
            height: 80,
            bottom: 80
          }
        ],
        xAxis: [
          {
            data: this.getData.map(item => item.tradeTime),
            type: "category",
            scale: true,
            boundaryGap: ['20%', '20%'],
            // inverse: true,
            axisLine: { onZero: false },
            splitLine: { show: false },
            splitNumber: 20,
            min: "dataMin",
            max: "dataMax"
          },
          {
            type: "category",
            gridIndex: 1,
            data: this.getData.map(item => item.tradeTime),
            scale: true,
            boundaryGap: ['20%', '20%'],
            axisLine: { onZero: false },
            axisTick: { show: false },
            splitLine: { show: false },
            axisLabel: { show: false },
            splitNumber: 20,
            min: "dataMin",
            max: "dataMax"
          }
        ],
        yAxis: [
          {
            scale: true,
            splitArea: {
              show: false // 去掉条纹色
            }
          },
          {
            scale: true,
            gridIndex: 1,
            splitNumber: 5,
            axisLabel: { show: false },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false }
          }
        ],
        dataZoom: [
          {
            type: "inside",
            xAxisIndex: [0, 1],
            start: this.startTime || 0,
            end: this.endTime || 100
          },
          {
            show: true,
            xAxisIndex: [0, 1],
            type: "slider",
            bottom: 10,
            start: this.startTime || 0,
            end: this.endTime || 100
          }
        ],
        visualMap: {
          show: false,
          seriesIndex: 1,
          dimension: 10,
          pieces: [
            {
              value: 1,
              color: upColor
            },
            {
              value: -1,
              color: downColor
            }
          ]
        },
        series: [
          {
            type: "candlestick",
            itemStyle: {
              color: upColor,
              color0: downColor,
              borderColor: upBorderColor,
              borderColor0: downBorderColor
            },
            encode: {
              x: 0,
              y: [1, 4, 3, 2]
            }
          },
          {
            name: "Volumn",
            type: "bar",
            xAxisIndex: 1,
            yAxisIndex: 1,
            itemStyle: {
              color: "#7fbe9e"
            },
            large: true,
            encode: {
              x: 0,
              y: 5
            }
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    myChartZoom() {
      const myChart = this.$echarts.init(document.getElementById("main"));
      const than = this;
      myChart.on("datazoom", function(params) {
        params = params.batch ? params.batch[0] : params;
        than.$emit("onZoomInit", params);
      });
    }
  },
  mounted() {
    // this.echartsInit();
    this.myChartZoom();
    window.addEventListener("resize", () => {
      this.$echarts.init(document.getElementById("main")).resize();
    });
  }
};
</script>
<style lang="less" scoped>
.Echarts {
  margin: 20px 0;
}
</style>
